// frontend/src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css'; // Optional: if you have global styles
import { AuthProvider } from './context/AuthContext';
import './customReports/choosing-the-right-learning-partner.css';


const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error("Couldn't find root element. Make sure your public/index.html has a div with id 'root'.");
}

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <AuthProvider>
    <App />
  </AuthProvider>
  </React.StrictMode>
);